import React, { useCallback, useEffect, useState } from 'react';
import { Button } from '@mui/material';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import Grid24 from '../../../components/UI/Grid24';
import { inspecionarProcessoPageController } from '../../InspecionarProcesso/inspecaoProcessoController';
import { loadingInspecaoProcessoController } from '../../InspecionarProcesso/loadingInspecaoProcessoController';
import EmailEntradaBorderoService from '../../../services/core/emailEntradaBordero/EmailEntradaBorderoService';
import TelefoneDevedor from '../../InspecionarProcesso/DadosDevedor/Telefone Devedor/TelefoneDevedor';
import EmailDevedor from '../../InspecionarProcesso/DadosDevedor/Email Devedor/EmailDevedor';
import { dadosDevedorController } from '../../InspecionarProcesso/DadosDevedor/dadosDevedorController';
import OptionDialogNew from '../../../components/UI/Dialogs/OptionDialog/OptionDialogNew';
import { buscarDadosTabelaAction } from '../../../store/EmailEntradaBordero/EmailEntradaBordero.saga';
import { useEmailEntradaBorderoDispatch } from '../../../store/EmailEntradaBordero/EmailEntradaBorderoProvider';


function DialogEditarDadosDevedorComponent({ setOpenEditDialog, idEmailEntradaBordero }) {
  const dispatch = useEmailEntradaBorderoDispatch();

  const [devedor, setDevedor] = useState(null);
  const [idProcesso, setIdProcesso] = useState(null);
  const [, setLoadings] = useState(loadingInspecaoProcessoController.makeLoadings());
  const [formFields, setFormFields] = useState(dadosDevedorController.makeFormFields(devedor, idProcesso));
  const immutableSelectors = useSelector(inspecionarProcessoPageController.makeImmutableSelectors);
  const [additionalInfos, setAdditionalInfos] = useState({});
  const [openConfirmarDialog, setOpenConfirmarDialog] = useState(false);


  const onChangeTelefoneHandler = useCallback((name, value, index) => {
    setFormFields((oldValue) => {
      const telefones = [...oldValue.telefones];
      telefones[index][name].onChange(value);
      return { ...oldValue, telefones };
    });
  }, []);

  const onFocusTelefoneHandler = useCallback((name, index) => {
    setFormFields((oldValue) => {
      const telefones = [...oldValue.telefones];
      telefones[index][name].onFocus();
      return { ...oldValue, telefones };
    });
  }, []);

  const setTelefonesHandler = useCallback((telefones) => {
    setFormFields(oldValue => ({ ...oldValue, telefones }));
  }, []);

  const onChangeEmailHandler = useCallback((name, value, index) => {
    setFormFields((oldValue) => {
      const emails = [...oldValue.emails];
      emails[index][name].onChange(value);
      return { ...oldValue, emails };
    });
  }, []);

  const onFocusEmailHandler = useCallback((name, index) => {
    setFormFields((oldValue) => {
      const emails = [...oldValue.emails];
      emails[index][name].onFocus();
      return { ...oldValue, emails };
    });
  }, []);

  const setEmailHandler = useCallback((emails) => {
    setFormFields(oldValue => ({ ...oldValue, emails }));
  }, []);

  const onClickConfirmar = useCallback(() => {
    const { telefones } = formFields;
    const { emails } = formFields;
    const payload = {
      emails: emails.map(email => ({
        email: email?.email?.value || null,
        principal: email?.principal?.value || false,
      })) || [],
      telefones: telefones.map(telefone => ({
        ddd: telefone.ddd.value,
        observacao: telefone.observacao.value,
        numero: telefone.numero.value,
        tipoTelefone: telefone.tipoTelefone.value,
        principal: telefone.principal.value,
        permitirWhatsApp: telefone.permitirWhatsApp.value,
      })) || [],
    };
    EmailEntradaBorderoService.salvarDadosDevedor(idEmailEntradaBordero, payload).then(() => {
      toast.success('Dados do Devedor atualizados com sucesso!');

      dispatch(buscarDadosTabelaAction());
      setOpenConfirmarDialog(false);
      setOpenEditDialog(false);
    }).catch(() => {
      toast.error('Erro ao atualizar os dados do Devedor.');
      setOpenConfirmarDialog(false);
    });
  }, [formFields, setOpenEditDialog, idEmailEntradaBordero, dispatch]);

  const onClickConfirmarDialog = useCallback(() => {
    onClickConfirmar();
  }, [onClickConfirmar]);

  useEffect(() => {
    if (idProcesso === null || devedor === null) {
      EmailEntradaBorderoService.buscarIdProcessoPorIdEmailEntradaBordero(idEmailEntradaBordero).then((response) => {
        if (!response.data) {
          return;
        }
        setIdProcesso(response.data);
        setLoadings(loadingInspecaoProcessoController.changeLoadingProcessoInfo(true));
        inspecionarProcessoPageController.loadMutableInfo(response.data).then((res) => {
          setDevedor(res.devedor);
          setAdditionalInfos(res.infoProcesso);
          inspecionarProcessoPageController.loadImmutableInfo();
          setFormFields(dadosDevedorController.makeFormFields(res.devedor, response.data));
        }).finally(() => {
          setLoadings(loadingInspecaoProcessoController.changeLoadingProcessoInfo(false));
        });
      });
    }
  }, [idEmailEntradaBordero, devedor, idProcesso]);

  return (
    <>
      <OptionDialogNew
        open={openConfirmarDialog}
        confirmLabel="Confirmar"
        cancelLabel="Cancelar"
        onClickCancel={() => { setOpenConfirmarDialog(false); }}
        onClickConfirm={() => onClickConfirmarDialog()}
        text="As alterações feitas no cadastro serão refletidas em todos os Processos que fizerem referência a este devedor. Confirma as alterações?"
      />
      <Grid24 isFormContainer>
        <TelefoneDevedor
          isEditMode
          devedor={devedor}
          podeModificarFase={additionalInfos?.podeModificarFase}
          immutableSelectors={immutableSelectors}
          formFields={formFields}
          setAttributeHandler={onChangeTelefoneHandler}
          setFocusHandler={onFocusTelefoneHandler}
          setTelefonesHandler={setTelefonesHandler}
        />
      </Grid24>
      <Grid24 container isFormContainer>
        <EmailDevedor
          isEditMode
          devedor={devedor}
          podeModificarFase={additionalInfos?.podeModificarFase}
          formFields={formFields}
          setAttributeHandler={onChangeEmailHandler}
          setFocusHandler={onFocusEmailHandler}
          setObjectsHandler={setEmailHandler}
        />
      </Grid24>
      <div style={{ display: 'flex', justifyContent: 'end', marginTop: '22px' }}>
        <Button
          onClick={() => { setOpenEditDialog(false); }}
        >
          Cancelar
        </Button>
        <Button
          onClick={() => { setOpenConfirmarDialog(true); }}
        >
          Confirmar
        </Button>
      </div>

    </>
  );
}

export const DialogEditarDadosDevedor = DialogEditarDadosDevedorComponent;
